// Generated from api/openapi/admin.yaml by make docs. Do not edit.
import { z } from "zod";

export const orgGrantSchema = z.object({
  "id": z.string().uuid(),
  "admin_user_id": z.string().uuid(),
  "tenant_id": z.string().uuid(),
  "organization_id": z.string().uuid(),
  "role": z.enum(["org_admin", "org_operator"]),
  "granted_by": z.string().uuid().optional(),
  "granted_at": z.string().datetime({ offset: true }),
  "expires_at": z.string().datetime({ offset: true }).optional(),
  "revoked_at": z.string().datetime({ offset: true }).optional(),
  "revoked_by": z.string().uuid().optional()
});

export const orgGrantListSchema = z.object({
  "items": z.array(orgGrantSchema)
});
